// pivotDefaults — deterministic pivot polish, code-side (zero prompt
// tokens). Excel's factory pivot ships "Sum of Monthly CTC" captions and
// raw unformatted values (743917.918273...) — the two loudest "raw Excel
// 2007" signals in an otherwise premium build. Pure string logic here;
// the Office.js glue in office.ts applies it.

// friendlyHierarchyName turns (field, aggregation) into the caption an
// analyst would write: "Total Revenue", not "Sum of Revenue".
export function friendlyHierarchyName(field: string, fn: string): string {
  const f = (fn || 'sum').toLowerCase().replace(/[_\s-]/g, '');
  switch (f) {
    case 'sum': return `Total ${field}`;
    case 'average':
    case 'avg':
    case 'mean': return `Avg ${field}`;
    case 'count':
    case 'countnumbers':
    case 'countnum': return `Count of ${field}`;
    case 'min': return `Min ${field}`;
    case 'max': return `Max ${field}`;
    case 'product': return `Product of ${field}`;
    case 'stdev': return `StdDev ${field}`;
    case 'var': return `Variance ${field}`;
    default: {
      const cap = fn.charAt(0).toUpperCase() + fn.slice(1).toLowerCase();
      return `${cap} of ${field}`;
    }
  }
}

// aggregationNumberFormat picks a readable default per aggregation:
// counts and totals as thousands-separated integers, averages/spreads
// with two decimals (a 4.2 rating must not render as 4).
export function aggregationNumberFormat(fn: string): string {
  const f = (fn || 'sum').toLowerCase().replace(/[_\s-]/g, '');
  switch (f) {
    case 'average':
    case 'avg':
    case 'mean':
    case 'stdev':
    case 'var':
      return '#,##0.00';
    default:
      return '#,##0';
  }
}
